export default __webpack_public_path__ + "static/media/yellow-note.d1ce75a2.png";